<template>
  <div
    class="uptime-placeholder"
    :aria-label="`Uptime chart for the past ${days} days, all ${status}`"
    role="img"
  >
    <div
      v-for="n in days"
      :key="n"
      class="uptime-placeholder__block"
      :class="`uptime-placeholder__block--${status}`"
    />
  </div>
</template>

<script setup lang="ts">
import type { StatusKind } from '@/types/status';

interface Props {
  days?: number;
  status?: StatusKind;
}

withDefaults(defineProps<Props>(), {
  days: 90,
  status: 'operational'
});
</script>

<style scoped lang="scss">
.uptime-placeholder {
  display: flex;
  flex-wrap: nowrap;
  gap: 2px;
  overflow: hidden;

  &__block {
    flex: 1;
    height: 32px;
    min-width: 4px;
    border-radius: 2px;

    &--operational {
      background: var(--ok);
    }

    &--degraded {
      background: var(--warn);
    }

    &--outage {
      background: var(--danger);
    }
  }
}
</style>
